/**
 * file-type-icon.js
 */

import React from 'react';
import 'file-icon-vectors/dist/file-icon-square-o.min.css';

export default function FileTypeIcon(props) {
  const ext = props.filename.split('.').pop().toLowerCase();

  return (
    <span className={`fiv-sqo fiv-icon-${ext} ${props.className}`} />
  )
}